(function(ebusy, $) {

	/**
	 * Parses a time string into minutes of day, or null if not parseable.
	 *
	 * Locale-tolerant: accepts 24h notation ("8", "08:30", "830", "8.30",
	 * "20,15", "8h30", "8 Uhr") as well as 12h notation with meridiem
	 * ("8:30 pm", "8pm", "12 a.m."), matching both the German ("HH:mm")
	 * and English ("h:mm a") display formats of the spinner options.
	 */
	var parseTimeToMinutes = function(text) {
		if (text === undefined || text === null) {
			return null;
		}

		text = String(text).trim().replace(/\s*uhr\.?$/i, "");

		var match = text.match(/^(\d{1,2})(?:\s*[:.,hH]?\s*(\d{2}))?\s*(?:([aApP])\.?\s*[mM]?\.?)?$/);
		if (!match) {
			return null;
		}

		var hours = parseInt(match[1], 10);
		var minutes = match[2] !== undefined ? parseInt(match[2], 10) : 0;
		var meridiem = match[3] ? match[3].toLowerCase() : null;

		if (minutes > 59) {
			return null;
		}

		if (meridiem) {
			if (hours < 1 || hours > 12) {
				return null;
			}
			if (hours === 12) {
				hours = 0;
			}
			if (meridiem === "p") {
				hours += 12;
			}
		} else if (hours > 23) {
			return null;
		}

		return hours * 60 + minutes;
	};

	/**
	 * Initializes spinner buttons.
	 */
	ebusy.initSpinner = function() {
		
		$(".form-spinner").each(function() {
			
			var spinner = $(this);
			
			// Guard: skip if already initialized
			if (spinner.data("spinner-initialized")) {
				return;
			}
			spinner.data("spinner-initialized", true);
		
			var $select = $("select", spinner);
			var $input = $("input", spinner);
			var $btnPrev = $(".btn-prev", spinner).parent();
			var $btnNext = $(".btn-next", spinner).parent();

			// Internal state (avoid repeated DOM reads for selected/next/prev and wrap-around)
			var wrapAround = !spinner.hasClass("spinner-no-wrap");
			var timeInput = spinner.hasClass("spinner-time-input");
			var state = {
				wrapAround: wrapAround,
				optionValues: [],
				optionTexts: [],
				optionMinutes: [],
				indexByValue: {},
				selectedIndex: 0
			};

			var rebuildOptions = function() {
				state.optionValues = [];
				state.optionTexts = [];
				state.optionMinutes = [];
				state.indexByValue = {};

				$("option", $select).each(function(i) {
					var v = $(this).val();
					var text = $(this).text();
					state.optionValues.push(v);
					state.optionTexts.push(text);
					if (timeInput) {
						state.optionMinutes.push(parseTimeToMinutes(text));
					}
					state.indexByValue[v] = i;
				});

				// Keep selectedIndex in sync with current select value
				var currentValue = $select.val();
				if (currentValue !== undefined && state.indexByValue[currentValue] !== undefined) {
					state.selectedIndex = state.indexByValue[currentValue];
				} else {
					state.selectedIndex = Math.min(state.selectedIndex, Math.max(state.optionValues.length - 1, 0));
				}

				// Update UI
				updateInput();
				updateDisabled();
			};

			var updateInput = function() {
				var idx = state.selectedIndex;
				$input.val(state.optionTexts[idx] || "");
			};

			var updateDisabled = function() {
				var numberOfOptions = state.optionValues.length;
				$(".btn-prev", spinner).attr("disabled", numberOfOptions <= 1);
				$(".btn-next", spinner).attr("disabled", numberOfOptions <= 1);
			};

			var setSelectedIndex = function(idx) {
				if (state.optionValues.length === 0) {
					return;
				}
				state.selectedIndex = idx;
				var v = state.optionValues[idx];
				$select.val(v);
				updateInput();
			};

			var getPrevIndex = function() {
				if (state.optionValues.length <= 1) return state.selectedIndex;
				var prevIdx = state.selectedIndex - 1;
				if (prevIdx < 0) {
					if (!state.wrapAround) return null;
					prevIdx = state.optionValues.length - 1;
				}
				return prevIdx;
			};

			var getNextIndex = function() {
				if (state.optionValues.length <= 1) return state.selectedIndex;
				var nextIdx = state.selectedIndex + 1;
				if (nextIdx >= state.optionValues.length) {
					if (!state.wrapAround) return null;
					nextIdx = 0;
				}
				return nextIdx;
			};

			var stepPrev = function() {
				var prevIdx = getPrevIndex();
				if (prevIdx === null) return false;
				setSelectedIndex(prevIdx);
				return true;
			};

			var stepNext = function() {
				var nextIdx = getNextIndex();
				if (nextIdx === null) return false;
				setSelectedIndex(nextIdx);
				return true;
			};

			// Public API for consumers (avoid DOM lookups)
			spinner.data("spinner", {
				rebuild: rebuildOptions,
				getState: function() { return $.extend(true, {}, state); },
				getSelectedIndex: function() { return state.selectedIndex; },
				getSelectedValue: function() { return state.optionValues[state.selectedIndex]; },
				getPrevIndex: getPrevIndex,
				getNextIndex: getNextIndex,
				setSelectedIndex: setSelectedIndex,
				setSelectedValue: function(v) {
					if (state.indexByValue[v] === undefined) return false;
					setSelectedIndex(state.indexByValue[v]);
					return true;
				}
			});

			// Initial build
			rebuildOptions();

			// Keep internal state in sync if select changes externally
			$select.off("change._spinner").on("change._spinner", function() {
				var v = $select.val();
				if (state.indexByValue[v] !== undefined) {
					state.selectedIndex = state.indexByValue[v];
					updateInput();
				}
			});

			// If options are manipulated externally, callers can trigger this event to resync
			spinner.off("spinner.rebuild").on("spinner.rebuild", function() {
				rebuildOptions();
			});

			if (state.optionValues.length > 1) {
				var timeout;
				var fireEvents = false;
				
				$btnPrev.off("mousedown mouseup mouseleave").on("mousedown", function() {
					if (!stepPrev()) {
						return false;
					}
					
					fireEvents = true;
					timeout = ebusy.easingTimeout(1000, 50, function() {
						stepPrev();
					});
					return false;
				}).on("mouseup", function() {
					if (timeout) {
						timeout.clear();
					}
					
					if (fireEvents) {
						$select.trigger("change");
						$(this).trigger("change-prev", {
							spinner: spinner,
							state: state
						});
					}
					
					return false;
				}).on("mouseleave", function() {
					if (timeout) {
						timeout.clear();
					}
				 return false;
				});
				
				$btnNext.off("mousedown mouseup mouseleave").on("mousedown", function() {
					if (!stepNext()) {
						return false;
					}
					
					fireEvents = true;
					timeout = ebusy.easingTimeout(1000, 50, function() {
						stepNext();
					});
					return false;
				}).on("mouseup", function() {
					if (timeout) {
						timeout.clear();
					}
					
					if (fireEvents) {
						$select.trigger("change");
						$(this).trigger("change-next", {
							spinner: spinner,
							state: state
						});
					}
					
					return false;
				}).on("mouseleave", function() {
					if (timeout) {
						timeout.clear();
					}
				 return false;
				});
			}

			if (timeInput) {

				// Closest available option for a typed time; earlier option wins on a tie
				var findClosestIndexByMinutes = function(minutes) {
					var bestIndex = null;
					var bestDiff = null;
					for (var i = 0; i < state.optionMinutes.length; i++) {
						var optionMinutes = state.optionMinutes[i];
						if (optionMinutes === null) {
							continue;
						}
						var diff = Math.abs(optionMinutes - minutes);
						if (bestDiff === null || diff < bestDiff) {
							bestDiff = diff;
							bestIndex = i;
						}
					}
					return bestIndex;
				};

				var commitTypedTime = function() {
					var minutes = parseTimeToMinutes($input.val());
					var targetIndex = minutes === null ? null : findClosestIndexByMinutes(minutes);

					if (targetIndex === null || targetIndex === state.selectedIndex) {
						// Not parseable or unchanged: restore the normalized display text
						updateInput();
						return;
					}

					var direction = targetIndex > state.selectedIndex ? "change-next" : "change-prev";
					setSelectedIndex(targetIndex);
					$select.trigger("change");
					spinner.trigger(direction, {
						spinner: spinner,
						state: state
					});
				};

				var stepByKey = function(step) {
					if (!step()) {
						return;
					}
					$select.trigger("change");
					spinner.trigger(step === stepNext ? "change-next" : "change-prev", {
						spinner: spinner,
						state: state
					});
				};

				$input.off("focus._spinner keydown._spinner blur._spinner")
					.on("focus._spinner", function() {
						var input = this;
						window.setTimeout(function() {
							input.select();
						}, 0);
					})
					.on("keydown._spinner", function(e) {
						if (e.key === "Enter") {
							e.preventDefault();
							this.blur();
						} else if (e.key === "Escape") {
							updateInput();
							this.blur();
						} else if (e.key === "ArrowUp") {
							e.preventDefault();
							stepByKey(stepNext);
						} else if (e.key === "ArrowDown") {
							e.preventDefault();
							stepByKey(stepPrev);
						}
					})
					.on("blur._spinner", function() {
						commitTypedTime();
					});
			}
		});
	};
	
})(window.ebusy = window.ebusy || {}, window.jQuery);

$(function() {
	
	/**
	 * Register handler on form init.
	 */
	$(document).on("form.init", function(e) {
		ebusy.initSpinner();
	});
	
	/**
	 * Init existing spinners.
	 */
	ebusy.initSpinner();
});